import React, { useRef } from "react";
import { useEffect, createContext } from "react";
import { ClustersService } from "../api/clusters";
const C3ClusterUpdateManagerContext = createContext(null);
const C3ClusterUpdateManager = ({ children, stage, userToken, }) => {
    useEffect(() => {
        const eventSource = ClustersService.clustersStream({ stage, userToken });
        return () => {
            eventSource.close();
        };
    }, [stage, userToken]);
    return (React.createElement(C3ClusterUpdateManagerContext.Provider, { value: null }, children));
};
const useClusterUpdate = ({ onUpdate }) => {
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;
    useEffect(() => {
        const handler = (event) => {
            onUpdateRef.current(event.detail);
        };
        window.addEventListener("clusterchange", handler);
        return () => {
            window.removeEventListener("clusterchange", handler);
        };
    }, [onUpdateRef]);
};
export { C3ClusterUpdateManager, useClusterUpdate };
